import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/release-notes_/$slug")({
  beforeLoad: ({ params }) => {
    throw redirect({ to: "/changelog/$slug", params: { slug: params.slug }, replace: true });
  },
});
